import { styled } from "webapp/styled-components";

const leftMarginWidth = 68;

export const CalendarScheduleStyle = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-grow: 1;

    padding-top: 8px;

    color: ${p => p.theme.fgColorDark};

    [role="button"] {
        cursor: pointer;
    }

    .event-container {
        position: absolute;
        left: ${leftMarginWidth}px;
        width: calc(100% - ${p => p.theme.pageMarginMedium}px - ${leftMarginWidth}px);
        top: 16px;

        pointer-events: none;
    }

    .event-container.clickable {
        pointer-events: auto;
    }

    .cal-day-picker.selected {
        .day-number {
            color: ${p => p.theme.accentForegroundColor};
            background-color: ${p => p.theme.primaryAccentColor};
        }
    }

    .cal-week-picker {
        padding: 0 ${p => p.theme.pageMarginMedium}px 12px;
    }

    .cal-date-header {
        ${p => p.theme.fontStyles.Header2}
        margin-bottom: 12px;
        text-align: center;

        > input {
            position: absolute;
            left: 0;
            top: 0;
            height: 0;
            width: 0;
        }
    }

    .time-block-label {
        ${p => p.theme.fontStyles.Header6};
        position: relative;
        top: -7px;
        text-align: right;
        color: ${p => p.theme.fgColorLight};

        transition: opacity 150ms;
    }

    .time-block-label.hidden {
        opacity: 0;
    }

    .time-block {
        display: grid;
        height: 50px;
        padding-right: ${p => p.theme.pageMarginMedium}px;

        grid-column-gap: 8px;
        grid-template-columns: ${leftMarginWidth - 8}px 1fr;

        .time-block-area {
            border-top: 1px solid ${p => p.theme.separatorColor};
        }
    }

    .cal-event {
        position: absolute;
        background-color: ${p => p.theme.primaryAccentColor}26;
        width: 100%;
        left: 0;

        border-left: 4px solid ${p => p.theme.primaryAccentColor};
        border-bottom: 1px solid ${p => p.theme.baseColor};

        display: flex;
        flex-direction: column;

        ${p => p.theme.fontStyles.Callout6};

        padding: 0 8px;

        overflow: hidden;

        .title {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            flex-shrink: 0;
        }

        transition: left 150ms, top 100ms, height 100ms, width 150ms;

        .time-block-label {
            ${p => p.theme.fontStyles.Header6};
            position: relative;
            top: -7px;
            text-align: right;
            width: ${leftMarginWidth - 8}px;
            color: ${p => p.theme.fgColorDark};

            background-color: ${p => p.theme.baseColor};
        }

        .start-time {
            position: absolute;
            right: calc(100% + 8px);
        }

        .end-time {
            position: absolute;
            top: calc(100% - 7px);
            right: calc(100% + 8px);
        }

        ::before {
            content: "";
            flex-shrink: 2;
            height: 8px;
            min-height: 0;
        }

        ::after {
            content: "";
            flex-shrink: 3;
            height: 8px;
            min-height: 0;
        }
    }

    .dragging {
        cursor: ns-resize;
    }

    .cal-event.selection {
        background-color: ${p => p.theme.primaryAccentColor}66;

        border-left: unset;

        pointer-events: auto;

        overflow: visible;

        .top-drag-handle {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 25px;
            max-height: 50%;

            cursor: ns-resize;

            ::before {
                content: "";
                position: absolute;
                left: calc(50% - 4px);
                top: -3px;
                width: 8px;
                height: 8px;
                border-radius: 100px;

                background-color: ${p => p.theme.primaryAccentColor};
            }
        }

        .bottom-drag-handle {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 25px;
            max-height: 50%;

            cursor: ns-resize;

            ::before {
                content: "";
                position: absolute;
                left: calc(50% - 4px);
                bottom: -4px;
                width: 8px;
                height: 8px;
                border-radius: 100px;

                background-color: ${p => p.theme.primaryAccentColor};
            }
        }
    }

    .cal-scroller {
        padding-top: 16px;
        overflow-y: auto;
        flex-grow: 1;
        flex-shrink: 1;
        height: 1px;
        position: relative;

        ::-webkit-scrollbar {
            display: none;
        }
    }
`;
